var Handlebars = require('/root/code/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=container.escapeExpression;

  return "<span class=\"label "
    + alias1(container.lambda(((stack1 = (depth0 != null ? depth0.view : depth0)) != null ? stack1.labelClassName : stack1), depth0))
    + "\">"
    + alias1(((helper = (helper = helpers.attribute || (depth0 != null ? depth0.attribute : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"attribute","hash":{},"data":data}) : helper)))
    + "</span>\n";
},"useData":true});